import { Pipe, ChangeDetectorRef } from "@angular/core";
import { ConfigurationService } from "./configuration.service";
export class BooleanConfigPipe {
    constructor(configurationService, ref) {
        this.configurationService = configurationService;
        this.ref = ref;
        this.configSpec = null;
        this.value = null;
        this.subscription = configurationService.configurationChanges.subscribe((configSpec) => {
            if (configSpec === this.configSpec) {
                this.configSpec = null;
                this.value = null;
                this.ref.markForCheck();
            }
        });
    }
    transform(configSpec) {
        if (configSpec !== this.configSpec) {
            this.configSpec = configSpec;
            this.value = null;
            this.configurationService.getBoolean(configSpec).then((value) => {
                this.value = value;
                this.ref.markForCheck();
            });
        }
        return this.value;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
BooleanConfigPipe.decorators = [
    { type: Pipe, args: [{
                name: 'booleanConfig',
                pure: false
            },] },
];
/** @nocollapse */
BooleanConfigPipe.ctorParameters = () => [
    { type: ConfigurationService, },
    { type: ChangeDetectorRef, },
];
//# sourceMappingURL=boolean-config.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/configuration/boolean-config.pipe.js
// module id = 417
// module chunks = 1